

































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import DocumentsDatatable from '@/components/DocumentsDatatable.vue';
import { namespace } from 'vuex-class';
import { Order } from '@/interfaces/order.interface';
import { shortDateFormat } from '@/helpers/helpers';

const ordersModule = namespace('orders');

@Component({
  components: {
    DocumentsDatatable
  }
})
export default class InvoiceView extends Vue {
  @ordersModule.State orders!: Order[];
  @ordersModule.Action fetchOneOrder!: any;
  @ordersModule.Action fetchOrders!: any;
  order: Order = {};

  async mounted() {
    await this.refreshOrder();
    this.bindKeys()
  }

  beforeDestroy() {
    this.unBindKeys();
  }

  private async refreshOrder() {
    await this.fetchOneOrder({orderUuid: this.orderUuid});
  }

  get orderUuid(): string {
    return this.$route.params['orderUuid'];
  }

  // TODO: Reassigning this.order each time store orders change, because .find loses reactivity. Find another way.
  @Watch('orders')
  updateOrder(): void {
    this.order = this.orders.find((o: Order) => o.uuid === this.orderUuid) || {};
  }

  // TODO: Just a placeholder
  getCurrentDate() {
    return Date();
  }

  get shortDateFormat(): string {
    return shortDateFormat;
  }

  private bindKeys() {
    window.addEventListener('keyup', this.onKeyUp);
  }

  private unBindKeys() {
    window.removeEventListener('keyup', this.onKeyUp);
  }

  async onKeyUp(event: KeyboardEvent) {
    if (['Escape'].indexOf(event.code) > -1) await this.$router.back();
  }
}
